import apiSheltersMap from '@/api/shelters-map'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  deleteSheltersMapStart: '[delete sheltersMap] delete sheltersMap start',
  deleteSheltersMapSuccess: '[delete sheltersMap] delete sheltersMap success',
  deleteSheltersMapFailure: '[delete sheltersMap] delete sheltersMap failure',
}

export const actionTypes = {
  deleteSheltersMap: '[delete sheltersMap] delete sheltersMap',
}

const mutations = {
  [mutationTypes.deleteSheltersMapStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteSheltersMapSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteSheltersMapFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.deleteSheltersMap](context, {id}) {
    context.commit(mutationTypes.deleteSheltersMapStart)
    return new Promise((resolve) => {
      apiSheltersMap
        .deleteSheltersMap(id)
        .then((response) => {
          context.commit(mutationTypes.deleteSheltersMapSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.deleteSheltersMapFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
